<template>
  <article>
    <div class="filter mt-20">
      <div class="filter__item">
        <div class="filter__name">名字：</div>
        <el-input v-model="filters.name" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="filter__item">
        <div class="filter__name">用户ID：</div>
        <el-input v-model="filters.acid" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="filter__item" v-if="[2, 4, 16].includes(opid)">
        <div class="filter__name">负责人：</div>
        <operSelect v-model="filters.opid" :lists.sync="operLists"/>
      </div>
      <button class="blue-small-btn" @click="getList">搜索</button>
      <div class="ml-auto">
        <button class="blue-small-btn" @click="createAdChnInfo">新建</button>
      </div>
      <!--
      <div class="filter__item">
        <div class="filter__name">时间：</div>
        <el-date-picker v-model="filters.dateTime" type="datetimerange" placeholder="选择时间范围" align="right" size="mini" class="date">
        </el-date-picker>
      </div>
      -->
    </div>
    <!--
    <div class="filter mt-20">
      <div class="filter__item">
        <div class="filter__name">状态：</div>
        <el-radio-group v-model="filters.status">
          <div class="dib mr-20">
            <el-radio :label="item.value" v-for="(item, index) in statusList" :key="index">{{item.name}}</el-radio>
          </div>
        </el-radio-group>
      </div>
      <button class="blue-small-btn" @click="getList">搜索</button>
    </div>
    -->
    <el-table :data="lists" highlight-current-row v-loading="listLoading" style="width: 100%;" class="mt-30" height="600">
      <el-table-column prop="acid" label="用户ID" width="" align="center">
      </el-table-column>
      <el-table-column label="名字" width="" align="center">
        <template slot-scope="scope">
          <div>{{scope.row.name}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="oper_nickname" label="负责人" width="" align="center">
        <template slot-scope="scope">
          <div>{{scope.row.oper_nickname}}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="" label="地址" width="300" align="center">
        <template slot-scope="scope">
          <i class="el-icon-edit" @click="editAddress(scope.$index)"></i>
          <div v-for="(item, index) in scope.row.address_lists" :key="index">
            <div class="fs-12">{{item['address']}}</div>
          </div>
        </template>
      </el-table-column>
      <!--
      <el-table-column prop="phone" label="电话号码" width="" align="center">
      </el-table-column>
      <el-table-column prop="qq" label="QQ" width="" align="center">
      </el-table-column>
      <el-table-column prop="wechat" label="微信" width="" align="center">
      </el-table-column>
      <el-table-column prop="email" label="邮箱" width="" align="center">
      </el-table-column>
      <el-table-column prop="alipay" label="支付宝账号" width="" align="center">
      </el-table-column>
      <el-table-column prop="alipay_name" label="支付宝姓名" width="" align="center">
      </el-table-column>
      <el-table-column prop="identity_card" label="身份证" width="" align="center">
      </el-table-column>
      <el-table-column prop="bank" label="银行" width="" align="center">
      </el-table-column>
      <el-table-column prop="bank_account" label="银行账号" width="" align="center">
      </el-table-column>
      <el-table-column prop="bank_name" label="收款人" width="" align="center">
      </el-table-column>
      -->
      <el-table-column prop="" label="创建时间" width="" align="center">
        <template slot-scope="scope">
          <div v-html="formatTimeStamp(scope.row.create_time)"></div>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" width="" fixed="right" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.status == 1" class="blue-small-btn" @click="changeUserinfo(scope.$index, 2)">正常</div>
          <div v-if="scope.row.status == 0" class="red-small-btn" @click="changeUserinfo(scope.$index, 2)">异常</div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="140" align="center" fixed="right">
        <template slot-scope="scope">
          <div class="flex">
            <button class="blue-small-btn" @click="editAdChnInfo(scope.$index)">编辑</button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination layout="total, sizes, pager, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="filters.l" :page-sizes="[20, 50, 80, 100]" :total="filters.total" :current-page="filters.p" class="tac mt-36 pb-36">
    </el-pagination>
    <el-dialog title="下家编辑" :visible.sync="adChnDialog" size="tiny" width="800px" center>
      <div class="flex fdr aic">
        <div class="dataForm">
          <div class="dataForm__item">
            <div class="dataForm__name">下家ID</div>
            <el-input v-model="adChnInfo.acid" placeholder="" size="mini" class="dataForm__input" :disabled="true"></el-input>
          </div>
          <div class="dataForm__item mt-20" v-if="adChnInfo.acid === 0">
            <div class="dataForm__name">微信号</div>
            <el-input v-model="adChnInfo.wechat" placeholder="" size="mini" class="dataForm__input"></el-input>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">下家名</div>
            <el-input v-model="adChnInfo.name" placeholder="" size="mini" class="dataForm__input"></el-input>
          </div>
        </div>
      </div>
      <div class="flex fdc aic">
        <div class="flex mt-30">
          <div class="blue-large-btn mr-20" @click="adChnEdit">保存</div>
          <div class="gray-large-btn" @click="adChnDialog = false">取消</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="地址编辑" :visible.sync="addressDialog" size="tiny" width="1000px" center>
      <div class="mb-20">
        <el-table ref="dataTable" :data="addressLists" highlight-current-row v-loading="listLoading" style="width: 100%;" class="" height="">
          <el-table-column prop="acaid" label="ID" width="" align="center">
          </el-table-column>
          <el-table-column prop="acid" label="下家ID" width="" align="center">
          </el-table-column>
          <el-table-column prop="address" label="地址" width="400" align="center">
            <template slot-scope="scope">
              <div class="flex jcc">
                <el-input v-model="scope.row.address" placeholder="" size="mini" class="dataForm__input"></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="sold" label="状态" width="200" align="center">
            <template slot-scope="scope">
              <el-radio-group v-model="scope.row.status">
                <div class="dib mr-20">
                  <el-radio :label="0">失效</el-radio>
                  <el-radio :label="1">运行</el-radio>
                </div>
              </el-radio-group>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="180" align="center" fixed="right">
            <template slot-scope="scope">
              <div class="flex jcc">
                <button class="blue-small-btn" @click="addressItmeEdit(scope.$index)">保存</button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="fs-25 flex jcc aic mb-20">地址新增</div>
      <div class="flex fdr aic ml-20">
        <div class="dataForm">
          <div class="dataForm__item">
            <div class="dataForm__name">ID</div>
            <el-input v-model="addressInfo.acaid" placeholder="" size="mini" class="dataForm__input" :disabled="true"></el-input>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">下家ID</div>
            <el-input v-model="addressInfo.acid" placeholder="" size="mini" class="dataForm__input" :disabled="true"></el-input>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">替换提示</div>
            <div class="mr-30">汉字替换(2-5位)：{replace}</div>
            <div class="mr-30">数字替换(2-4位)：{digit}</div>
            <div class="mr-30">小写字母替换(2-4位)：{alphabet}</div>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">地址</div>
            <el-input type="textarea" :rows="4" v-model="addressInfo.address" placeholder="填多个，请使用 | 分割" size="mini" class="dataForm__input"></el-input>
          </div>
        </div>
      </div>
      <div class="flex fdc aic">
        <div class="flex mt-30">
          <div class="blue-large-btn mr-20" @click="addressEdit">保存</div>
          <div class="gray-large-btn" @click="addressDialog = false">取消</div>
        </div>
      </div>
    </el-dialog>
  </article>
</template>

<script>
import mixinList from '../../../mixins/list'
import util from '../../../script/util'
import {adChnLists, adChnEdit, adChnAddressEdit} from '../../../api/api'
import operSelect from '../../../components/data-select/operSelect.vue'
export default {
  name: 'adChnList',
  mixins: [mixinList],
  components: {
    operSelect
  },
  data () {
    return {
      opid: '',
      statusList: [
        {
          name: '所有',
          value: ''
        },
        {
          name: '正常',
          value: 1
        },
        {
          name: '异常',
          value: 0
        }
      ],
      lists: [],
      listLoading: false,
      operLists: [],
      dialog: false,
      filters: {
        p: 1,
        l: 20,
        total: 0,
        name: '',
        acid: '',
        opid: '',
        dateTime: '',
        start_time: '',
        end_time: '',
        status: ''
      },
      adChnDialog: false,
      adChnInfo: {
        acid: 0,
        name: '',
        wechat: ''
      },
      addressDialog: false,
      addressLists: [],
      addressInfo: {
        acaid: 0,
        acid: '',
        address: ''
      }
    }
  },
  methods: {
    // 格式化时间
    formatTimeStamp (time) {
      return util.formatTimeStamp(time)
    },
    handleSizeChange (val) {
      this.filters.l = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.filters.p = val
      this.getList()
    },
    initAdChnInfo () {
      for (let key in this.adChnInfo) {
        this.adChnInfo[key] = ''
      }
      this.adChnInfo.acid = 0
    },
    createAdChnInfo () {
      this.adChnDialog = true
      this.initAdChnInfo()
    },
    editAdChnInfo (index) {
      this.adChnDialog = true
      for (let key in this.adChnInfo) {
        this.adChnInfo[key] = this.lists[index][key]
      }
    },
    editAddress (index) {
      this.addressDialog = true
      this.addressInfo['acaid'] = 0
      this.addressInfo['acid'] = this.lists[index]['acid']
      this.addressInfo['address'] = ''
      this.addressLists = this.lists[index]['address_lists']
    },
    adChnEdit () {
      let params = {
        acid: this.adChnInfo.acid,
        name: this.adChnInfo.name
      }

      let content = ''

      if (params['name'] === '') {
        content = '名字不能为空'
      }

      if (params['acid'] === 0) {
        params['opid'] = this.opid
        params['wechat'] = this.adChnInfo.wechat
        if (params['wechat'] === '') {
          content = '微信名不能为空'
        }
      }

      if (content) {
        this.$notify({
          title: '失败',
          message: content,
          type: 'error'
        })
        return
      }

      adChnEdit(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '保存成功',
            type: 'success'
          })
          this.adChnDialog = false
          this.initAdChnInfo()
          this.getList()
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    },
    addressItmeEdit (index) {
      let params = {
        acaid: this.addressLists[index]['acaid'],
        address: this.addressLists[index]['address'],
        status: this.addressLists[index]['status']
      }

      this.adChnAddressEdit(params)
    },
    addressEdit () {
      let params = {
        acaid: this.addressInfo.acaid,
        acid: this.addressInfo.acid,
        address: this.addressInfo.address
      }

      this.adChnAddressEdit(params)
    },
    adChnAddressEdit (params) {
      adChnAddressEdit(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '保存成功',
            type: 'success'
          })
          this.addressDialog = false
          this.getList()
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    },
    getList () {
      let filters = this.filters
      let params = {
        p: filters.p,
        l: filters.l,
        opid: this.opid
      }
      if (filters.name !== '') {
        params.name = filters.name
      }
      if (filters.acid !== '') {
        params.acid = filters.acid
      }
      if ([2, 4, 16].includes(this.opid)) {
        if (filters.opid !== '') {
          params.opid = filters.opid
        } else {
          delete params.opid
        }
      }
      if (filters.status !== '') {
        params.status = filters.status
      }
      if (filters.start_time !== '') {
        params.start_time = filters.start_time
      }
      if (filters.end_time !== '') {
        params.end_time = filters.end_time
      }
      this.listLoading = true
      adChnLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          data.d.lists.forEach((item) => {
            item.isChoose = ''
          })
          this.lists = data.d.lists
          this.filters.total = data.d.total
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
        this.$notify({
          title: '失败',
          message: '服务器出错了',
          type: 'error'
        })
      })
    },
    changeUserinfo (index, oper) {
      let status = this.lists[index].status
      let acid = this.lists[index].acid

      if (oper === 2) {
        status = this.lists[index].status === 1 ? 0 : 1
      }

      let params = {
        status: status,
        acid: acid
      }
      adChnEdit(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '提交成功',
            type: 'success'
          })
          this.getList()
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    },
    dateTimeChange () {
      if (this.filters.dateTime) {
        this.filters.start_time = parseInt(new Date(this.filters.dateTime[0]).getTime() / 1000)
        this.filters.end_time = parseInt(new Date(this.filters.dateTime[1]).getTime() / 1000)
      } else {
        this.filters.start_time = ''
        this.filters.end_time = ''
      }
    }
  },
  mounted () {
    this.opid = parseInt(window.localStorage.getItem('opid'))

    this.getList()
  },
  watch: {
    'filters.acid': 'getList',
    'filters.opid': 'getList',
    'filters.name': 'getList'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/module/ad/adChnList.vue